import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/local/endoscopeAppointment',
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue'),
  },
  {
    name: 'Authorization',
    path: '/login/authorization',
    component: () => import(/* webpackChunkName: "authorization" */ '../views/login/authorization.vue'),
  },
  {
    name: 'localEndoscopeAppointment',
    path: '/local/endoscopeAppointment',
    component: () => import(/* webpackChunkName: "localList" */ '../views/local/list.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'localNewAppointment',
    path: '/local/newAppointment',
    component: () => import(/* webpackChunkName: "localList" */ '../views/local/list.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'fillResultEntry',
    path: '/fill/resultEntry',
    component: () => import(/* webpackChunkName: "localList" */ '../views/local/list.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'fillReport',
    path: '/fill/report',
    component: () => import(/* webpackChunkName: "localReport" */ '../views/fill/report.vue'),
    meta: {
      keepAlive: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
